__webpack_require__.p = "https://au.knowledgesearchcore.thomsonreuters.com/";